/**
 * Format innings pitched in baseball notation (where 1/3 = ⅓ and 2/3 = ⅔)
 * @param {number} innings - Number of innings pitched
 * @returns {string} - Formatted innings value
 */
export const formatInnings = (innings) => {
    if (typeof innings === 'number') {
      const wholePart = Math.floor(innings);
      const decimalPart = innings - wholePart;
      
      // Convert decimal to baseball fraction notation
      if (decimalPart === 0) return wholePart.toString();
      
      // Handle different possible decimal representations
      // Check for values close to 1/3 (0.33, 0.333, 0.3333, etc.)
      if (decimalPart >= 0.3 && decimalPart < 0.4) {
        return `${wholePart}⅓`;
      }
      // Check for values close to 2/3 (0.66, 0.667, 0.6667, etc.)
      else if (decimalPart >= 0.6 && decimalPart < 0.7) {
        return `${wholePart}⅔`;
      }
      // Also handle the case where innings might be stored as 0.1 for 1/3 and 0.2 for 2/3
      else if (decimalPart === 0.1) {
        return `${wholePart}⅓`;
      }
      else if (decimalPart === 0.2) {
        return `${wholePart}⅔`;
      }
      
      // If we can't determine the fraction, just return the number with one decimal place
      return innings.toFixed(1);
    }
    return innings;
  };
  
  /**
   * Format a numerical value as a baseball statistic
   * @param {number} value - The value to format
   * @param {number} precision - Number of decimal places
   * @param {boolean} isPercentage - Whether this is a percentage value
   * @returns {string} - Formatted statistic
   */
  export const formatStat = (value, precision = 3, isPercentage = false) => {
    if (value === undefined || value === null) return '-';
    
    const formatted = value.toFixed(precision).replace(/^0+/, '');
    return isPercentage ? `${formatted}%` : formatted;
  };
  
  /**
   * Format a date for display
   * @param {Date|string} date - Date to format
   * @returns {string} - Formatted date
   */
  export const formatDate = (date) => {
    if (!date) return '';
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };
